import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, model, signal, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormsModule } from "@angular/forms";
import { FieldType } from "@ngx-formly/core";
import { TranslatePipe } from "@ngx-translate/core";
import { AutoFocusModule } from "primeng/autofocus";
import { ButtonModule } from "primeng/button";
import { CustomEntityColumnSelectOption } from "../../../../generated/generated-types";
import { PhxCheckboxComponent } from "../../../../shared/components/phx-input-checkbox/phx-input-checkbox.component";
import { PhxInputComponent } from "../../../../shared/components/phx-input/phx-input.component";

@Component({
  selector: 'app-formly-select-option-input-widget',
  imports: [
    FormsModule,
    PhxInputComponent,
    PhxCheckboxComponent,
    AutoFocusModule,
    ButtonModule,
    TranslatePipe,
    CommonModule
  ],
  templateUrl: './formly-select-option-input-widget.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlySelectOptionInputWidgetComponent extends FieldType implements ControlValueAccessor, AfterViewInit {
  selectOptions = model<CustomEntityColumnSelectOption[]>([{}]);

  valuesAreDifferent = signal(false);

  constructor(
    public cdRef: ChangeDetectorRef,
  ) {
    super();
  }

  ngAfterViewInit(): void {
    let initialValue: CustomEntityColumnSelectOption[] = this.formControl?.value;
    if (initialValue?.length > 0) {
      if (initialValue.some(x => x.value && x.value != x.label))
        this.valuesAreDifferent.set(true);
      this.selectOptions.set([...this.formControl.value, {}]);
    }

    this.formControl?.valueChanges.subscribe(value => {
      this.selectOptions.set([...value, {}]);
    });
  }

  optionChanged(_option?: CustomEntityColumnSelectOption) {
    let optionsWithoutValue = this.selectOptions().filter(x => !x.label || x.label.length == 0);
    if (optionsWithoutValue.length == 0) {
      this.selectOptions.update(x => {
        x.push({});
        return x;
      });
    }
    else if (optionsWithoutValue.length > 1) {
      for (let option of optionsWithoutValue.slice(1))
        this.selectOptions.update(x => {
          x.splice(x.indexOf(option), 1);
          return x;
        });
    }

    this.updateValue();
  }

  updateValue() {
    this.formControl?.setValue(this.selectOptions().filter(x => x.label && x.label.length > 0)
      // .map(x => {
      //   x.value = x.value ?? x.label;
      // })
    );
    this.onChange?.(this.selectOptions());
  }

  onValuesAreDifferentChange(isDifferent: boolean) {
    if (!isDifferent) {
      this.selectOptions.update(options => options.map(o => ({ ...o, value: null })));
      this.updateValue();
    }
    this.cdRef.detectChanges();
  }

  deleteOption(option: CustomEntityColumnSelectOption) {
    this.selectOptions.update(x => {
      x.splice(x.indexOf(option), 1);
      return x;
    });
  }

  //#region ControlValueAccessor
  onChange: (value: CustomEntityColumnSelectOption[]) => void;
  onTouched: () => void;

  writeValue(obj: any): void {
    this.formControl?.setValue(obj);
  }
  registerOnChange(fn: (value: CustomEntityColumnSelectOption[]) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled)
      this.formControl?.disable();
    else
      this.formControl?.enable();
  }
  //#endregion
}
